import axios from "axios";

const instance = axios.create({
    baseURL:"https://us-central1-medical-70178.cloudfunctions.net/api"
    // "http://localhost:5001/medical-70178/us-central1/api"
     //API (CLOUD FUNCTION) URL
}); 

export default instance;